import { render, staticRenderFns } from "./SliderWidget.vue?vue&type=template&id=fec0b020&lang=pug&"
import script from "./SliderWidget.vue?vue&type=script&lang=js&"
export * from "./SliderWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports